import request from '@/core/http/request'

// 销售转采购（后台转单）
export function transferOrder_addPurchasesOrderDocFromSalesOrder(data) {
    return request({
        url: '/qingguang/tenantbussiness/transferOrder/addPurchasesOrderDocFromSalesOrder',
        method: 'post',
        data: data
    })
}

// 销售单转请购单
export function transferOrder_addRequisitionOrderDocFromSalesOrder(data) {
    return request({
        url: '/qingguang/tenantbussiness/transferOrder/addRequisitionOrderDocFromSalesOrder',
        method: 'post',
        data: data
    })
}

// 请购单转采购单
export function transferOrder_addPurchasesOrderDocFromRequisitionOrder(data) {
    return request({
        url: '/qingguang/tenantbussiness/transferOrder/addPurchasesOrderDocFromRequisitionOrder',
        method: 'post',
        data: data
    })
}

// 精细报价转销售
export function transferOrder_addSalesOrderDocFromFineQuotationDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/transferOrder/addSalesOrderDocFromFineQuotationDoc',
        method: 'post',
        data: data
    })
}

// 销售批量转采购
export function smgtSalesOrderDocDetail_selectSalesOrderListForPurchaseByIds(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/selectSalesOrderListForPurchaseByIds',
        method: 'post',
        data: data
    })
}

// 物料需求转采购
export function material_queryMaterialPurchasePriceListForPurchaseDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/material/queryMaterialPurchasePriceListForPurchaseDoc',
        method: 'post',
        data: data
    })
}

// 请购转询价中转接口
export function pmgtPurchasesRequistionDoc_purchasesInquiryDocFromPurchasesRequisitionDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesRequistionDoc/purchasesInquiryDocFromPurchasesRequisitionDoc',
        method: 'post',
        data: data
    })
}

// 询价转采购中转接口
export function pmgtPurchaseInquiryDoc_purchasesDocFromPurchasesInquiryDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchaseInquiryDoc/purchasesDocFromPurchasesInquiryDoc',
        method: 'post',
        data: data
    })
}

// 销售转询价
export function transferOrder_addPurchaseInquiryDocFromSalesOrder(data) {
    return request({
        url: '/qingguang/tenantbussiness/transferOrder/addPurchaseInquiryDocFromSalesOrder',
        method: 'post',
        data: data
    })
}

// 销售报价转询价
export function transferOrder_addPurchaseInquiryDocFromSalesQuotationDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/transferOrder/addPurchaseInquiryDocFromSalesQuotationDoc',
        method: 'post',
        data: data
    })
}

// 供应商报价转询价
export function transferOrder_addPurchaseInquiryDocFromSupplierQuotationDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/transferOrder/addPurchaseInquiryDocFromSupplierQuotationDoc',
        method: 'post',
        data: data
    })
}
